function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

class DatepickerInput extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onDateValueChange", () => {
      console.log('date value changed');
    });

    this.onDateValueChange = this.onDateValueChange.bind(this);
  }

  render() {
    return /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "form-control date",
      id: "dash-daterange",
      onClick: this.props.onClick,
      value: this.props.value,
      onChange: this.onDateValueChange
    });
  }

}

class DatepickerInputWithAddon extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "form-control form-control-light",
      id: "dash-daterange",
      onClick: this.props.onClick,
      value: this.props.value,
      readOnly: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "input-group-append"
    }, /*#__PURE__*/React.createElement("span", {
      className: "input-group-text bg-primary border-primary text-white"
    }, /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-calendar-range font-13"
    }))));
  }

}

class HyperDatepicker extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleDateSelectChange", date => {
      this.setState({
        startDate: date
      });
      this.props.onChange(date);
    });

    this.state = {
      startDate: new Date()
    };
    this.handleDateSelectChange = this.handleDateSelectChange.bind(this);
  }

  render() {
    const input = (this.props.hideAddon || false) === true ? /*#__PURE__*/React.createElement(DatepickerInput, null) : /*#__PURE__*/React.createElement(DatepickerInputWithAddon, null);
    return /*#__PURE__*/React.createElement(DatePicker, _extends({}, this.props, {
      customInput: input,
      selected: this.state.startDate,
      onChange: this.handleDateSelectChange
    }));
  }

}

export default HyperDatepicker;